import React from 'react';
import {
  DialogTitle as MuiDialogTitle,
  DialogTitleProps as MuiDialogTitleProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';

type DialogTitleProps = MuiDialogTitleProps & {
  children?: any;
};

export const DialogTitle = ({ children = null, sx, ...rest }: DialogTitleProps) => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <MuiDialogTitle
      sx={{
        paddingLeft: down_sm ? 3 : 8,
        paddingRight: down_sm ? 1.5 : 4,
        paddingTop: 4,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MuiDialogTitle>
  );
};
